import React from "react"
// eslint-disable-next-line no-restricted-imports
import { Container, Icon, Text, Tooltip } from "@carrotfertility/carotene" // please do not import from @carrotfertility/carotene after eslint rule added on 3/20/25
import { FormattedMessage } from "react-intl"

export default function RemoveEmailTooltip({ color = "carrotOrange" }: { color?: string }): JSX.Element {
  return (
    <Tooltip
      anchor={<Icon size={"small"} name="helpCircle" color={color} />}
      content={
        <Container maxWidth={"300px"}>
          <Text>
            <FormattedMessage defaultMessage="If you remove this address, our messages will go to the address you use for signing in to Carrot." />
          </Text>
        </Container>
      }
    />
  )
}
